import React from 'react'
import {Row, Col, Typography, Collapse, Avatar, Spin, Divider} from 'antd'
import { useGetCryptoExchangesQuery } from '../services/cryptoApi';
import millify from 'millify';
import HTMLReactParser from 'html-react-parser';

const { Text } = Typography;
const { Panel } = Collapse

const Exchanges = () => {
    const { data, isFetching } = useGetCryptoExchangesQuery()

    if(isFetching) return <Spin />

    


    return (
        !data ? 'nothing here' :  data?.data?.exchanges?.map((exchange, i) => (
            <Collapse defaultActiveKey={['1']} >
                <Panel key={exchange.id} showArrow={false} header={
                
                    <Row>
                        <Col span={6}>
                            
                                <Text>{i + 1}. </Text>
                                <Divider type="vertical" />
                                <Avatar src={exchange.iconUrl} alt={exchange.name} />
                                <Divider type="vertical" />
                                <Text> {exchange.name}</Text>
                                          
                       </Col>
                      
                       <Col span={6}>
                            <p>{millify(exchange.volume)}</p>
                       </Col>
                       <Col span={6}>
                            <p>{millify(exchange.numberOfMarkets)}</p>
                       </Col>
                       <Col span={6}>
                            <p>{millify(exchange.marketShare)}%</p>
                       </Col>
                    </Row>
                    
                } >
                    <Text>{HTMLReactParser(`${exchange.description || ''}`)}</Text>
                </Panel>
        </Collapse>
       ))
    )
}

export default Exchanges
